module.exports = __webpack_public_path__ + "img/paike.0c196a5d.png";